import { UnifiedReservationDailyOccupancy } from '@hkm/types/reservation/models/UnifiedReservationDailyOccupancy';

import { HousekeepingRoomDailyOccupancyDetailsDto } from '@ac/library-api';
import { AttendantAssignmentReservationDailyOccupancy } from '@ac/library-api/dist/types/entities/roomAssignment/attendantAssignment/attendantAssignmentReservationDailyOccupancy';

export function mapReservationDailyOccupancy(
  dailyOccupancy: AttendantAssignmentReservationDailyOccupancy
): UnifiedReservationDailyOccupancy;
export function mapReservationDailyOccupancy(
  dailyOccupancy: HousekeepingRoomDailyOccupancyDetailsDto
): UnifiedReservationDailyOccupancy {
  return dailyOccupancy;
}



// WEBPACK FOOTER //
// ./src/types/reservation/mappers/mapReservationDailyOccupancy.ts